import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import HomePage2 from '../HomePage2/HomePage2';
import AboutPage from '../AboutPage/AboutPage';
import EventSinglePage from '../EventSinglePage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogDetails from '../BlogDetails/BlogDetails'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import EventPageS2 from "../EventPageS2/EventPageS2";
import LanguageProvider from "../../context/LanguageContext";
//import UnderConstructionPage from "../ErrorPage/UnderConstructionPage";
import { isSupported, detectInitialLang } from "../../utils/lang";

// Routes under the active `/:lang` segment. Paths are relative to that segment.
const LangRoutes = () => (
  <Routes>
    <Route index element={<HomePage2 />} />
    <Route path="home" element={<HomePage2 />} />
    <Route path="about" element={<AboutPage />} />
    <Route path="service" element={<ServicePage />} />
    <Route path="service-single/:slug" element={<ServiceSinglePage />} />
    <Route path="event" element={<EventPageS2 />} />
    <Route path="event-single/:slug" element={<EventSinglePage />} />
    {/*
    <Route path="blog" element={<UnderConstructionPage section={'blog'} />} />
    <Route path="blog/:slug" element={<UnderConstructionPage section={'blog'}   />} />
    <Route path="blog-single/:slug" element={<UnderConstructionPage section={'blog'}  />} />
    */}
    <Route path="blog" element={<BlogPage />} />
    <Route path="blog/:slug" element={<BlogDetails />} />
    <Route path="blog-single/:slug" element={<BlogDetails />} />
    <Route path="contact" element={<ContactPage />} />
    <Route path="*" element={<ErrorPage />} />
  </Routes>
);

// Validates the `:lang` path segment. Unprefixed or invalid-lang URLs (including
// legacy links like `/blog?lang=fr`) are redirected to the detected language,
// preserving the rest of the path so bookmarks don't 404.
const LangGate = () => {
  const { lang } = useParams();
  const location = useLocation();

  if (!isSupported(lang)) {
    const target = `/${detectInitialLang()}${location.pathname}`;
    return <Navigate to={target} replace />;
  }

  return (
    <LanguageProvider>
      <LangRoutes />
    </LanguageProvider>
  );
};

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:lang/*" element={<LangGate />} />
          <Route
            path="*"
            element={<Navigate to={`/${detectInitialLang()}`} replace />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
